const type = {
    PROGRESS : 'progress',
    ALERT : 'alert',
    USER_DETAIL : 'userDetail'
};
export default type;
